import { render, staticRenderFns } from "./Video.vue?vue&type=template&id=98429e8e&"
import script from "./Video.vue?vue&type=script&lang=ts&"
export * from "./Video.vue?vue&type=script&lang=ts&"
import style0 from "./Video.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AdaptiveImageNew: require('/tmp/build_dc55b0b5/src/components/media/AdaptiveImageNew.vue').default,BlockVideoPlayer: require('/tmp/build_dc55b0b5/src/components/block/VideoPlayer.vue').default})
